export default "__VITE_ASSET__BjU32OSY__"